// src/components/profile-detail/LoadingState.jsx
import React from "react";
import { 
  Container, 
  Box, 
  CircularProgress, 
  Typography,
  useTheme 
} from "@mui/material";

const LoadingState = () => {
  const theme = useTheme();

  return (
    <Container maxWidth="lg" sx={{ py: 12, textAlign: 'center' }}>
      <Box 
        sx={{ 
          position: 'relative', 
          display: 'inline-block',
          mb: 3
        }}
      >
        {/* Outer Glow Effect */}
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 100,
            height: 100,
            borderRadius: '50%',
            backgroundColor: theme.palette.primary.alpha['10'],
            animation: 'pulse 2s ease-in-out infinite'
          }}
        />
        
        {/* Circular Progress */}
        <CircularProgress 
          size={80} 
          thickness={4} 
          sx={{ 
            color: theme.palette.primary.light,
            position: 'relative',
            zIndex: 2,
            animation: 'spin 1.5s linear infinite'
          }} 
        />
        
        {/* Heart Icon */}
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          fontSize: '1.5rem',
          fontWeight: 700,
          color: theme.palette.primary.light,
          animation: 'heartbeat 1.5s ease-in-out infinite',
          zIndex: 3
        }}>
          ♡
        </Box>
      </Box>
      
      {/* Loading Text */}
      <Typography 
        variant="h5" 
        color={theme.palette.text.primary} 
        sx={{ 
          mb: 1,
          fontWeight: 700,
          animation: 'fadeInOut 2s ease-in-out infinite'
        }}
      >
        Loading Profile
      </Typography>
      
      <Typography 
        variant="body1" 
        color={theme.palette.text.secondary}
        sx={{ 
          mb: 4,
          maxWidth: 400,
          mx: 'auto'
        }}
      >
        Finding your perfect match...
      </Typography>
      
      {/* Loading Dots */}
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
        {[0, 1, 2].map((index) => (
          <Box
            key={index}
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              backgroundColor: theme.palette.primary.light,
              animation: `bounce 1.4s ease-in-out infinite ${index * 0.16}s`,
              opacity: 0.7
            }}
          />
        ))}
      </Box>

      {/* Custom CSS Animations */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        @keyframes pulse {
          0%, 100% { 
            opacity: 0.5; 
            transform: translate(-50%, -50%) scale(1);
          }
          50% { 
            opacity: 0.8; 
            transform: translate(-50%, -50%) scale(1.1);
          }
        }
        
        @keyframes heartbeat {
          0%, 100% { 
            transform: translate(-50%, -50%) scale(1);
          }
          50% { 
            transform: translate(-50%, -50%) scale(1.2);
          }
        }
        
        @keyframes fadeInOut {
          0%, 100% { 
            opacity: 0.8; 
          }
          50% { 
            opacity: 1; 
          }
        }
        
        @keyframes bounce {
          0%, 80%, 100% { 
            transform: scale(0);
          } 
          40% { 
            transform: scale(1);
          }
        }
      `}</style>
    </Container>
  );
};

export default LoadingState;